export default [
    {
        path: '/time-sheet-schedules',
        name: 'time-sheet-schedules',
        component: () => import ('./views/ScheduleIndex'),
        meta: {
            title: 'Agendamentos de Folha de Ponto',
            icon: 'mdi-av-timer',
        }
    },
]
